<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <TitleComponent title="2 .Tus abonos" subtitle="Completa la información necesaria para cada uno de los abonos seleccionados"></TitleComponent>
            </div>
            <div class="col-12 mb-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="select_all" id="select_all">
                    <label class="custom-control-label" for="select_all">Seleccionar todos los abonos</label>
                </div>
            </div>
            <div class="col-12 mb-3">
                <Button @click.prevent="volver">Cambiar butacas</Button>
            </div>
            <div class="col-12">
                <div class="row" id="datos-abonos">
                    <template v-for="(abono, index) in datos_de_compradores">
                        <b-col lg="4" md="6" sm="12" :key="index">
                            <DatosAbonoComponent
                                v-if="loading != index"
                                :area="abono.area"
                                :abono="abono"
                                :generos="generos"
                                :index="index"
                                :precios="zona_precios"
                                :zona="zona"
                                v-on:actualizado="actualizar(index)"
                                v-on:borrar="borrar(index)"
                                :desactivar="desactivar"
                                :validator="$refs.observer"
                            />
                        </b-col>
                    </template>
                </div>
            </div>
            <template v-if="tienenPrecio">
                <div class="col-12">
                    <TitleComponent title="3. Finalizar compra" subtitle="Selecciona un método de pago, descuento y finaliza tu compra"></TitleComponent>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="metodo_pago">Método de pago</label>
                        <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                            <multiselect
                                v-if="metodos_pago"
                                id="metodo_pago"
                                v-model="datos_compra.metodo_pago"
                                placeholder="Método de pago"
                                label="nombre"
                                :multiple="permitirVariosMetodosPago"
                                :options="metodos_pago"
                                :class="(errors[0] ? 'is-invalid' : '')"
                                @select="setMetodosDePago"
                                @remove="deleteMetodoDePago"
                                :disabled="disabled"
                                trackBy="id"
                            />
                        </ValidationProvider>
                    </div>
                    <template v-if="datos_compra.metodo_pago != null && datos_compra.metodo_pago.valor == 9">
                        <FormInput label="IBAN" name="IBAN" rules="required" v-model="datos_compra.iban" />
                        <FormInput label="Titular de la cuenta" name="Titular de la cuenta" rules="required" v-model="datos_compra.titular_cuenta" />
                    </template>
                </div>
                <b-col 
                    v-if="show_desglose && datos_compra.metodo_pago && datos_compra.metodo_pago.length > 1"
                    cols="12"
                >
                    <b-row>
                        <template v-for="(abono, index) in datos_de_compradores" >
                            <DesgloseMetodoPagoAbono
                                v-if="abono.precio"
                                :key="index"
                                :importe="abono.precio.precio_total_taquilla"
                                :descuento_aplicado="parseFloat(abono.descuento_aplicado)"
                                :descuento_integro="parseFloat(abono.descuento_integro)"
                                :metodos_pago="abono.metodo_pago"
                                :numero="++index"
                                @error="abono.error = true"
                                @valido="abono.error = false"
                                :disabled="disabled"
                            />
                        </template>
                    </b-row>
                </b-col>
                <div class="col-12">
                    <Button 
                        id="continuar-paso3" 
                        type="submit" 
                        class="btn-block"
                        :disabled="disabled"
                    >
                        CONTINUAR COMPRA
                    </Button>
                </div>
            </template>
        </div>
    </ValidationObserver>
</template>

<script>
import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
import DatosAbonoComponent from '@/components/backend/stepper/components/DatosAbonoComponent';
import Generos from "@/mixins/Generos";
import DesgloseMetodoPagoAbono from './components/DesgloseMetodoPagoAbono.vue';

export default {
    props: ['datos_compradores', 'precios', 'zona', 'disabled'],
    mixins: [Generos],
    data() {
        return {
            datos_compra: {
                concepto: '',
                metodo_pago: null,
                modalidad: 0,
                tipo: false,
            },
            metodos_pago: null,
            select_all: false,
            loading: 999,
            zona_precios: null,
            desactivar: false,
            datos_de_compradores: this.datos_compradores,
            show_desglose: false
        }
    },
    created() {
        this.metodos_pago = this.teatro.metodos_pago_abonos_bases.slice().filter(metodo_pago => metodo_pago.show_taquilla);

        for(var i in this.datos_de_compradores) {
            if(this.datos_de_compradores[i].area) {
                this.datos_de_compradores[i].area.unidades = 0;
            }
        }

        this.getGeneros();
        this.getTipoAbonoPrecio();
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
        tienenPrecio() {
            let precio = true;

            Object.values(this.datos_de_compradores).forEach(abono => {
                if(abono.precio == undefined) {
                    precio = false;
                }
            })

            return precio;
        },
        permitirVariosMetodosPago() {
            let price_management_interno = 1;
            Object.values(this.datos_de_compradores).forEach(abono => {
                if(abono.precio && abono.precio.price_management_taquilla_interno == 0) {
                    price_management_interno = 0;
                }
            })

            return price_management_interno == 0 ? false : true;
        }
    },
    methods: {
        scrollTo(paso) {
            this.$scrollTo(paso, 100)
        },
        goTo(paso) {
            this.$emit('goTo', paso, this.datos_compra);
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                if(this.datos_compra.metodo_pago.length > 1) {
                    let error = false;

                    Object.values(this.datos_de_compradores).forEach(abono => {
                        if(abono.error) {
                            error = true;
                        }
                    });

                    if(! error) {
                        this.desactivar = true;
                        this.goTo(4);
                    }
                } else {
                    this.desactivar = true;
                    this.goTo(4);
                }                
            } else {
                this.$nextTick(function() {
                    this.scrollTo('.is-invalid');
                });
            }
        },
        actualizar(index) {
            if(this.select_all && index == 0) {
                for(var i in this.datos_de_compradores) {
                    var datos = Object.assign({}, this.datos_de_compradores[index]);
                    var asiento = Object.assign({}, this.datos_de_compradores[i].asiento);
                    var plaza = Object.assign({}, this.datos_de_compradores[i].plaza);
                    this.datos_de_compradores[i] = datos;
                    this.datos_de_compradores[i].asiento = asiento;
                    this.datos_de_compradores[i].plaza = plaza;
                    this.loading = i;
                }
            } else {
                var datos2 = Object.assign({}, this.datos_de_compradores[index]);
                var asiento2 = Object.assign({}, this.datos_de_compradores[index].asiento);
                var plaza2 = Object.assign({}, this.datos_de_compradores[index].plaza);
                this.datos_de_compradores[index] = datos2;
                this.datos_de_compradores[index].asiento = asiento2;
                this.datos_de_compradores[index].plaza = plaza2;
                this.loading = index;
            }
            this.loading = 999;
        },
        borrar(index) {
            delete this.datos_de_compradores[index];

            var tempDatos = {};
            var orderedIndex = 0;
            for(const i in this.datos_de_compradores) {
                tempDatos[orderedIndex] = this.datos_de_compradores[i];
                orderedIndex++;
            }

            this.datos_de_compradores = tempDatos;
            this.$emit("actualizar", this.datos_de_compradores);
        },
        volver() {
            this.$emit('volver');
        },
        getTipoAbonoPrecio() {
            const params = {
                filters: {
                    zona_id: this.zona.id
                },
                zona_id: this.zona.id
            };
            this.$store.dispatch(this.config.getVuexAlias('back.zonas.precios'), params).then(res => {
                this.zona_precios = res.data.data;
            });
        },
        setMetodosDePago(selected, id) {
            this.show_desglose = false;
            if(this.permitirVariosMetodosPago) {
                Object.values(this.datos_de_compradores).forEach(abono => {
                    if(abono.metodo_pago === undefined) {
                        abono.metodo_pago = [];
                    }

                    abono.metodo_pago.push(Object.assign({}, selected))

                    if(abono.metodo_pago.length == 1) {
                        abono.metodo_pago[0].importe = abono.precio.precio_total_taquilla; 
                    }
                })

                this.$emit("actualizar", this.datos_de_compradores);
            }
            this.$nextTick(() => {
                this.show_desglose = true;
            })      
        },
        deleteMetodoDePago(deleted, id) {
            this.show_desglose = false;
            Object.values(this.datos_de_compradores).forEach(abono => {
                if (abono.metodo_pago) {
                    for (let index = 0; index < abono.metodo_pago.length; index++) {
                        if(abono.metodo_pago[index].valor == deleted.valor) {
                            abono.metodo_pago.splice(index, 1);
                        }
                    }
                }
            })

            this.$emit("actualizar", this.datos_de_compradores);
            this.$nextTick(() => {
                this.show_desglose = true;
            })
        }
    },
    components: {
        TitleComponent, DatosAbonoComponent, DesgloseMetodoPagoAbono
    }
}    
</script>
